export default "__VITE_ASSET__ClgeGogt__"